<template>
  <div class="login-page">
    <section class="brand-panel" aria-label="擎天柱系统品牌介绍">
      <div class="brand-content">
        <div class="brand-lockup">
          <img :src="logoMark" class="brand-mark" alt="擎天柱系统 Logo">
          <div>
            <div class="brand-name">擎天柱系统</div>
            <div class="brand-slogan">让增长流程清晰可见</div>
          </div>
        </div>
        <div class="brand-capabilities" aria-label="系统核心能力">
          <span>商品洞察</span>
          <span>内容增长</span>
          <span>营销自动化</span>
        </div>
      </div>
      <div class="brand-footnote">OPERATION INTELLIGENCE</div>
    </section>

    <main class="auth-panel">
      <div class="auth-shell">
        <div class="mobile-brand">
          <img :src="logoMark" class="mobile-brand-mark" alt="">
          <span>擎天柱系统</span>
        </div>
        <div class="auth-heading">
          <div class="auth-eyebrow">运营工作台</div>
          <h1>欢迎回来</h1>
          <p>登录擎天柱系统，继续管理你的业务流程</p>
        </div>

        <el-form
          ref="form"
          class="login-form"
          :model="form"
          :rules="rules"
          label-position="top"
          @submit.native.prevent
        >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="form.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
            autocomplete="username"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            prefix-icon="el-icon-lock"
            type="password"
            show-password
            placeholder="请输入密码"
            autocomplete="current-password"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-alert
          v-if="errorMessage"
          class="login-error"
          :title="errorMessage"
          type="error"
          show-icon
          :closable="false"
        />
          <el-button
            type="primary"
            native-type="submit"
            class="login-button"
            :loading="loading"
            @click="submit"
          >
            登录
          </el-button>
      </el-form>

        <div class="security-note">
          <i class="el-icon-lock" aria-hidden="true"></i>
          <span>安全登录 · 数据仅用于内部运营</span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { login } from '../api'
import logoMark from '../assets/qingtianzhu-aurora-mark.png'

export default {
  data() {
    return {
      logoMark,
      loading: false,
      errorMessage: this.$route.query.reason === 'expired' ? '登录已过期，请重新登录' : '',
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        this.errorMessage = ''
        try {
          const data = await login(this.form)
          this.$store.commit('setAuth', data)
          const redirect = this.safeRedirect(this.$route.query.redirect)
          this.$router.replace(redirect || '/customer-development-tasks')
        } catch (error) {
          const responseData = error.response?.data
          this.errorMessage = typeof responseData === 'string'
            ? (responseData.includes('Proxy error') ? '后端服务未连接，请确认本地后端已启动' : responseData)
            : responseData?.message || error.message || '登录失败，请稍后重试'
        } finally {
          this.loading = false
        }
      })
    },
    safeRedirect(value) {
      if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return ''
      return value.startsWith('/login') ? '' : value
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(520px, 53%) minmax(440px, 47%);
  background: #ffffff;
  color: #142036;
}

.brand-panel {
  position: relative;
  display: flex;
  min-height: 100vh;
  overflow: hidden;
  padding: clamp(48px, 6vw, 92px);
  box-sizing: border-box;
  background-color: #111633;
  background-image: url('../assets/qingtianzhu-login-command-center.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  color: #ffffff;
}

.brand-content {
  position: relative;
  z-index: 1;
  width: 100%;
  padding-top: clamp(48px, 7vh, 76px);
  box-sizing: border-box;
}

.brand-lockup {
  display: flex;
  align-items: center;
  gap: 26px;
  max-width: 680px;
}

.brand-mark {
  width: clamp(82px, 7.6vw, 112px);
  height: clamp(82px, 7.6vw, 112px);
  flex: 0 0 auto;
  object-fit: contain;
  filter: drop-shadow(0 10px 28px rgba(95, 83, 232, 0.28));
}

.brand-name {
  font-size: clamp(34px, 3.2vw, 52px);
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0;
  text-shadow: 0 2px 16px rgba(0, 30, 72, 0.42);
}

.brand-slogan {
  margin-top: 15px;
  color: rgba(255, 255, 255, 0.84);
  font-size: clamp(20px, 1.9vw, 30px);
  line-height: 1.45;
  letter-spacing: 0;
}

.brand-capabilities {
  display: flex;
  align-items: center;
  gap: 0;
  margin-top: 44px;
  font-size: clamp(16px, 1.45vw, 22px);
  font-weight: 550;
  color: rgba(255, 255, 255, 0.9);
}

.brand-capabilities span {
  padding: 0 28px;
  border-left: 1px solid rgba(116, 184, 255, 0.42);
}

.brand-capabilities span:first-child {
  padding-left: 0;
  border-left: 0;
}

.brand-footnote {
  position: absolute;
  left: clamp(48px, 6vw, 92px);
  bottom: 34px;
  z-index: 1;
  color: rgba(171, 211, 255, 0.56);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.22em;
}

.auth-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 64px clamp(40px, 6vw, 88px);
  box-sizing: border-box;
  background-color: #f6f6fc;
  background-image: url('../assets/qingtianzhu-aurora-header.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: auto 260px;
}

.auth-shell {
  width: min(100%, 480px);
  padding: 44px;
  background: #fff;
  border: 1px solid #e1e4ef;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(31, 38, 78, .12);
}

.mobile-brand {
  display: none;
}

.auth-heading {
  margin-bottom: 38px;
}

.auth-eyebrow {
  margin-bottom: 12px;
  color: #5146e5;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.auth-heading h1 {
  margin: 0;
  color: #142036;
  font-size: clamp(36px, 3.1vw, 48px);
  line-height: 1.2;
  font-weight: 720;
  letter-spacing: 0;
}

.auth-heading p {
  margin: 14px 0 0;
  color: #718096;
  font-size: 16px;
  line-height: 1.7;
}

.login-form ::v-deep .el-form-item {
  margin-bottom: 26px;
}

.login-form ::v-deep .el-form-item__label {
  padding: 0 0 10px;
  color: #27344a;
  font-size: 15px;
  line-height: 22px;
  font-weight: 650;
}

.login-form ::v-deep .el-input__inner {
  height: 58px;
  padding-left: 48px;
  border: 1px solid #d7dfeb;
  border-radius: 10px;
  background: #ffffff;
  color: #142036;
  font-size: 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.login-form ::v-deep .el-input__inner::placeholder {
  color: #a4afc0;
}

.login-form ::v-deep .el-input__inner:hover {
  border-color: #9eb7dc;
}

.login-form ::v-deep .el-input__inner:focus {
  border-color: #5146e5;
  box-shadow: 0 0 0 4px rgba(81, 70, 229, 0.1);
}

.login-form ::v-deep .el-input__prefix {
  left: 14px;
}

.login-form ::v-deep .el-input__icon {
  color: #8c9ab0;
  font-size: 19px;
  line-height: 58px;
}

.login-form ::v-deep .el-form-item__error {
  padding-top: 6px;
  font-size: 13px;
}

.login-button {
  width: 100%;
  height: 58px;
  margin-top: 4px;
  border-color: #5146e5;
  border-radius: 10px;
  background: #5146e5;
  font-size: 16px;
  font-weight: 650;
  letter-spacing: 0.08em;
  box-shadow: 0 12px 28px rgba(81, 70, 229, 0.22);
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.login-button:hover,
.login-button:focus {
  border-color: #4338ca;
  background: #4338ca;
  box-shadow: 0 14px 32px rgba(81, 70, 229, 0.28);
  transform: translateY(-1px);
}

.login-button:active {
  transform: translateY(0);
}

.login-error {
  margin: -4px 0 22px;
  border-radius: 8px;
}

.security-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 52px;
  color: #9aa5b5;
  font-size: 13px;
}

.security-note i {
  color: #7d8ca4;
}

@media (max-width: 1120px) {
  .login-page {
    grid-template-columns: minmax(420px, 48%) minmax(440px, 52%);
  }

  .brand-panel {
    padding: 54px 44px;
  }

  .brand-content {
    padding-top: 42px;
  }

  .brand-lockup {
    align-items: flex-start;
    gap: 18px;
  }

  .brand-capabilities {
    align-items: flex-start;
    flex-direction: column;
    gap: 13px;
    margin-top: 34px;
  }

  .brand-capabilities span,
  .brand-capabilities span:first-child {
    padding: 0;
    border-left: 0;
  }

  .brand-footnote {
    left: 44px;
  }
}

@media (max-width: 860px) {
  .login-page {
    display: block;
    min-height: 100vh;
    background: #ffffff;
  }

  .brand-panel {
    display: none;
  }

  .auth-panel {
    min-height: 100vh;
    padding: 44px 24px;
  }

  .mobile-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 60px;
    color: #142036;
    font-size: 18px;
    font-weight: 700;
  }

  .auth-shell {
    transform: none;
  }

  .mobile-brand-mark {
    width: 42px;
    height: 42px;
    padding: 7px;
    border-radius: 10px;
    box-sizing: border-box;
    background: #0a3267;
    object-fit: contain;
  }

  .auth-heading {
    margin-bottom: 32px;
  }

  .auth-heading h1 {
    font-size: 36px;
  }

  .auth-heading p {
    max-width: 360px;
    font-size: 15px;
  }

  .security-note {
    margin-top: 40px;
  }
}

@media (max-height: 720px) and (min-width: 861px) {
  .auth-panel {
    align-items: flex-start;
    overflow-y: auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .auth-heading {
    margin-bottom: 24px;
  }

  .auth-shell {
    transform: none;
  }

  .login-form ::v-deep .el-form-item {
    margin-bottom: 18px;
  }

  .security-note {
    margin-top: 28px;
  }
}
</style>
